import { render, staticRenderFns } from "./ElPaymentProvider.vue?vue&type=template&id=08776baa"
import script from "./ElPaymentProvider.vue?vue&type=script&lang=js"
export * from "./ElPaymentProvider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports